import type { SVGProps } from "react";
// generated from Pause.svg — do not edit manually
// prettier-ignore
export default function Pause(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 6 5 V 19 H 9 V 5 H 6 Z" stroke="currentColor" strokeWidth="1.5"/><path d="M 18 5 V 19 H 15 V 5 H 18 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
